import { AspectRatioImage } from '@/components/AspectRatioImage/AspectRatioImage';
import { useIsMdUp } from '@/hooks/useMedia';

import type { CardImageProps } from './MobileImage';

import * as S from '../MediaWrapper.styles';

export const DesktopImage = (props: CardImageProps) => {
  const {
    _focalPoint,
    _image,
    alt,
    aspectRatioData,
    className,
    loaderProps,
    mediaWrapperType,
    preload,
    setLoadingState,
    sizes,
    useLoader,
    width,
    widths,
  } = props;

  const isMdUp = useIsMdUp();

  return (
    <S.DesktopImageWrapper
      $imageLength={_image.length}
      $mediaWrapperType={mediaWrapperType}
      data-testid='desktopCardImageBox'
    >
      {_image.map((cardImg, index) => {
        return (
          cardImg && (
            <AspectRatioImage
              key={`${cardImg.url}-${index}`}
              alt={alt ?? ''}
              aspectRatio={aspectRatioData}
              className={className ?? 'default'}
              data-test-id='MediaWrapperAspectRatioImage'
              focalPoint={{
                x: _focalPoint?.focalPoint?.x as number,
                y: _focalPoint?.focalPoint?.y as number,
              }}
              loaderProps={loaderProps}
              loading={preload && isMdUp ? 'eager' : 'lazy'}
              mediaWrapperType={mediaWrapperType}
              originalImageDimensions={{
                x: cardImg.width as number,
                y: cardImg.height as number,
              }}
              setLoadingState={(state: string) =>
                setLoadingState && setLoadingState(state)
              }
              showFallbackPlaceholder
              sizes={sizes ?? ''}
              src={cardImg.url as string}
              useLoader={useLoader ?? false}
              width={width ?? '100%'}
              widths={widths}
            />
          )
        );
      })}
    </S.DesktopImageWrapper>
  );
};
